const bookmarkData = [
  {name: 'Github', url: 'https://github.com/', icon_path: '/bookmark/github.png'},
  {name: 'StackOverflow', url: 'https://stackoverflow.com/', icon_path: '/bookmark/stackoverflow.png'},
  {name: '知乎', url: 'https://www.zhihu.com/', icon_path: '/bookmark/zhihu.png'},
  {name: '掘金', url: 'https://juejin.cn/', icon_path: '/bookmark/juejin.png'},
  
  {name: 'Bilibili', url: 'https://www.bilibili.com/', icon_path: '/bookmark/bilibili.png'},
  {name: 'Acfun', url: 'https://www.acfun.cn/', icon_path: '/bookmark/acfun.png'},
  {name: '淘宝', url: 'https://www.taobao.com/', icon_path: '/bookmark/taobao.png'},
  {name: '京东', url: 'https://www.jd.com/', icon_path: '/bookmark/jingdong.png'},

  
  {name: 'MDN', url: 'https://developer.mozilla.org/zh-CN', icon_path: '/bookmark/mdn.png'},
  {name: '搜狗翻译', url: 'https://fanyi.sogou.com/', icon_path: '/bookmark/sougou-fanyi.png'},
  {name: 'Python文档', url: 'https://docs.python.org/zh-cn/3/', icon_path: '/bookmark/python.png'},
  {name: '思否', url: 'https://segmentfault.com/', icon_path: '/bookmark/segmentfault.png'},

  {name: 'Gitee', url: 'https://gitee.com/', icon_path: '/bookmark/gitee.png'},
  {name: 'Google', url: 'https://www.google.com/', icon_path: '/bookmark/google.png'},
  {name: 'Wiki', url: 'https://zh.wikipedia.org/', icon_path: '/bookmark/wikipedia.png'},
  {name: '标准CPP', url: 'https://isocpp.org/', icon_path: '/bookmark/standrand_cpp.png'},
]

export {
  bookmarkData
}